const Corporate: React.FC = () => <div>
    <p>Kncept Pty Ltd is based in Melbourne, Australia, and provides physical services in the City Center, and Belgrave and Surrounds, though we can service other locations on request.</p>
    <p>Our registered Australian Business Number is 34 645 744 538.</p>
    <p>If you need to contact us, our email is <a href="mailto:custom.koncept@gmail.com">custom.koncept@gmail.com</a>.</p>
    <p></p>

</div>

export default Corporate